import api from "./interceptorServices"
import { API_URL } from "./ApiURL"
import { getCookie } from "../utils/cookies"

const getAuthConfig = () => {
  const token = getCookie("accesstoken")

  return {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  }
}

const GetBetsPerAgent = async (body) => {
  try {
    const { data } = await api.post(
      `${API_URL}bet/betperagent`,
      body,
      getAuthConfig()
    )
    return data
  } catch (error) {
    console.log(error?.response?.data || error)
  }
}

const GetBets = async (body) => {
  try {
    const { data } = await api.post(
      `${API_URL}bet/bettranscation`,
      body,
      getAuthConfig()
    )
    return data
  } catch (error) {
    console.log(error?.response?.data || error)
  }
}

const GetWinningPerAgent = async (body) => {
  try {
    const { data } = await api.post(
      `${API_URL}report/getwinningbetsperteller`,
      body,
      getAuthConfig()
    )
    return data
  } catch (error) {
    console.log(error?.response?.data || error)
  }
}

export { GetBetsPerAgent, GetBets, GetWinningPerAgent }
